export const sexualOrientationOptions = [
  { value: "HeterosexualOrStraight", label: "Heterosexual or Straight" },
  { value: "GayOrLesbian", label: "Gay or Lesbian" },
  { value: "Bisexual", label: "Bisexual" },
  { value: "OtherNotListed", label: "Other not listed" },
  { value: "NotSure", label: "Not sure" },
  { value: "PreferNotToSay", label: "Prefer not to say" },
];
